import NiceModal, { useModal } from '@ebay/nice-modal-react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { t } from 'i18next'

export const InvalidDeleteRoleModal = NiceModal.create(() => {
  const modal = useModal()

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          width: '32.563rem',
          padding: '1.5rem',
          borderRadius: '0.25rem'
        }
      }}
      open={modal.visible}
      onClose={() => modal.remove()}
    >
      <DialogTitle sx={{ padding: '1rem 1.5rem' }}>
        <Typography fontWeight='bold' variant='h6' component='span'>
          {t('invalid_delete_role_modal.title')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: '1.5rem !important' }}>
        <Typography>{t('invalid_delete_role_modal.content')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={() => modal.remove()}
          sx={{
            borderRadius: '0.5rem',
            border: '1px solid rgba(121, 134, 203, 0.60)',
            background: 'rgba(121, 134, 203, 0.16)',
            color: 'rgba(121, 134, 203, 0.60)',
            textTransform: 'capitalize'
          }}
        >
          {t('common.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
})
